import React from 'react'

export default function PaneWrapper({ children }) {
  return (
    <div
      id="admin-pane-middle"
      className="app-pane pane column-flex"
    >
      <div className="vertical release-list-view">
        {children}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/release/components/PaneWrapper.js